export default __webpack_public_path__ + "static/media/buttons.c34950e1.svg";